import { Notify } from '../interface';

const initialNotifyState: Notify = {
    // list of notifications
    notifications: [],
};

export default initialNotifyState;



// WEBPACK FOOTER //
// ./src/redux/initial-state/notify.ts